import { createAction } from '@reduxjs/toolkit'

import type { AttachFilePayload, FetchAuthPayload } from './types'

export const RequestActions = {
  attachFile: createAction<AttachFilePayload>('REQUESTS_ATTACH_FILE'),
  fetchAuth: createAction<FetchAuthPayload | undefined>('REQUESTS_FETCH_AUTH'),
}
